import { UserTypes } from "./UserTypes";
import { OrganizationTypes } from "./OrganizationTypes";
import { UserRoles } from "./UserRoles";
import { CertificateWithSecretVersionTypes } from "./CertificateWithSecretVersionTypes";
import {BlockchainOwnerAddress} from "./BlockchainOwnerAddress"
import { ConsumptionTypes } from "./ConsumptionTypes";
import { MaintenanceActionTypes } from "./MaintenanceActionTypes";
import { TOAST_AUTO_HIDE_DURATION_IN_MS } from "./Miscellaneous";
import { MapConstants } from "./MapConstants";
import * as Colors from "./Colors";



export const constants = {
  UserTypes,
  OrganizationTypes,
  UserRoles,
  CertificateWithSecretVersionTypes,
  BlockchainOwnerAddress,
  ConsumptionTypes,
  MaintenanceActionTypes,
  MapConstants,
  TOAST_AUTO_HIDE_DURATION_IN_MS,
  Colors
}



// WEBPACK FOOTER //
// ./src/constants/index.js